import { ProfileNameForm } from '../components/ProfileNameForm'
import { ProfilePhoneForm } from '../components/ProfilePhoneForm'
import { AUTH_PROFILE, PROFILE_FIELD } from '../constants/auth'
import { cx } from '../helpers/format'
import { useProfilePage } from '../hooks/useProfilePage'
import '../styles/profile-page.scss'

export function ProfilePage() {
  const {
    displayName,
    initials,
    memberSince,
    fields,
    editing,
    busy,
    message,
    startEdit,
    nameForm,
    phoneForm,
  } = useProfilePage()

  return (
    <div className="profile-page">
      <header className="profile-page__head">
        <span className="profile-page__avatar" aria-hidden>
          {initials}
        </span>
        <div>
          <h1>{AUTH_PROFILE.greeting(displayName)}</h1>
          {memberSince ? (
            <p className="profile-page__since">{AUTH_PROFILE.memberSince(memberSince)}</p>
          ) : null}
        </div>
      </header>
      <section className="profile-page__section">
        <h2>{AUTH_PROFILE.detailsTitle}</h2>
        <p className="profile-page__lead">{AUTH_PROFILE.detailsLead}</p>
        <dl className="profile-page__fields">
          {fields.map((field) => {
            const isEditing = editing === field.id
            return (
              <div
                key={field.id}
                className={cx('profile-page__field', isEditing && 'profile-page__field--editing')}
              >
                <div className="profile-page__field-head">
                  <dt>{field.label}</dt>
                  {field.editable && !isEditing ? (
                    <button
                      type="button"
                      className="profile-page__edit"
                      aria-label={AUTH_PROFILE.editAria(field.label)}
                      onClick={() => startEdit(field.id)}
                      disabled={busy}
                    >
                      {field.hasValue ? AUTH_PROFILE.edit : AUTH_PROFILE.add}
                    </button>
                  ) : null}
                </div>
                <dd>
                  {isEditing && field.id === PROFILE_FIELD.name ? (
                    <ProfileNameForm {...nameForm} />
                  ) : isEditing && field.id === PROFILE_FIELD.phone ? (
                    <ProfilePhoneForm {...phoneForm} />
                  ) : (
                    field.value
                  )}
                </dd>
              </div>
            )
          })}
        </dl>
        {message ? (
          <p className="profile-page__message" role="status">
            {message}
          </p>
        ) : null}
      </section>
    </div>
  )
}
